import axios from 'axios'
import { VueAxios } from './axios'
import downLoadExcel from '@/utils/downloadExcel'
// import { Message } from 'element-ui'
import DonMessage from './message'
import store from '@/store'
import { setToken, getUserLanguage } from './auth'
const Message = new DonMessage()
const service = axios.create({
  baseURL: process.env.VUE_APP_BASEURL,
  timeout: 60 * 1000,
  isRetryRequest: false
})
// 请求拦截
service.interceptors.request.use(
  config => {
    if(config.url.includes('/terminal/debug/directory/')|| config.url.includes('/terminal/debug/download')){
      config.timeout = 1000 * 60 * 60 * 24
    }else {
      config.timeout =  60 * 1000
    }
    if (store.getters.token) {
      config.headers['Authorization'] = store.getters.token
    }
    if (config.method === 'get') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    } else {
      config.headers['Content-Type'] = 'application/json'
    }
    config.headers['language'] = getUserLanguage()
    return config
  },
  error => {
    Message.error({
      message: vm.$t('request.outTime'),
      duration: 2 * 1000
    })
    Promise.reject(error)
  }
)
// 响应拦截
service.interceptors.response.use(response => {
  const token = response.headers.authorization
  if (token) {
    store.commit('setToken', token)
    setToken(token)
  }
  // 下载excel
  if (response.config.responseType === 'arraybuffer') {
    var buffers = response.data
    var blob = new Blob([buffers], {
      type: 'text/plain'
    })
    var reader = new FileReader()
    reader.readAsArrayBuffer(blob)
    // console.log(reader.result)
      // var buf = new Uint8Array(reader.result)
      // reader.readAsText(new Blob([buf]), 'utf-8')
      reader.onload = function() {
        if (typeof reader.result === 'string' && reader.result.indexOf('code') > -1) {
          // response.data = JSON.parse(reader.result)
          const res = JSON.parse(reader.result)
          Message.error({
            message: res.message || vm.$t('request.downFail'),
            duration: 2 * 1000
          })
        } else {
          if (response.status === 200 && response.data) {
            downLoadExcel(response)
          }
        }
      }
  }
  // code 0:表示成功 其他表示失败
  if (response.data.code === 0) {
    return response
  } else {
    response.data.message && Message.error({
      message: response.data.message,
      duration: 2 * 1000
    })
    return Promise.reject(response)
  }
},
error => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        store.dispatch('logout')
        .then(() => {
          location.reload()
        })
        break
      default:
        break
    }
  }

  // Error: Request failed with status code 504
  // Message.error({
  //   message: vm.$t('request.Network'),
  //   duration: 2 * 1000
  // })
  console.error(vm.$t('request.Network'))
  // 请求超时或者网络错误
  if (window.vm) {
    // window.vm.$router.push({ path: '/500' })
  }

  return Promise.reject(error)
}
)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}
export default service
export {
  installer as VueAxios,
  service as axios
}
